import { render, staticRenderFns } from "./Fidelidade.vue?vue&type=template&id=d3c06ab2&scoped=true"
import script from "./Fidelidade.vue?vue&type=script&lang=js"
export * from "./Fidelidade.vue?vue&type=script&lang=js"
import style0 from "./Fidelidade.vue?vue&type=style&index=0&id=d3c06ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c06ab2",
  null
  
)

export default component.exports